export default "__VITE_ASSET__5fFTNe4k__"